module.exports = __webpack_public_path__ + "static/DrumKitGame-60ac258910607347c87b77e5f1217e16.png";